import React from "react";
import {
  Button,
  Container,
  Data,
  Desc,
  Img,
  ProjectBg,
  ProjectTitle,
  Section,
} from "./ProjectStyles";
import { UilMessage } from "@iconscout/react-unicons";

const Project = () => {
  return (
    <Section>
      <ProjectBg>
        <Container>
          <Data>
            <ProjectTitle>You have a new project?</ProjectTitle>
            <Desc>Contact me now and get a 30% discount</Desc>
            <Button
              to="contact-section"
              activeClass="active"
              spy={true}
              smooth={true}
              offset={30}
              duration={300}
              hashSpy={true}
            >
              Contact Me
              <UilMessage size="1.25rem" className="btn__icon project__icon" />
            </Button>
          </Data>
          <Img src="/img/project.png" alt="img" />
        </Container>
      </ProjectBg>
    </Section>
  );
};

export default Project;
